import Route from "vue-routisan";
import auth_routes from "./authRoutes";
import shipper_routes from "./logisticManager/shipperRoutes";
import transporter_routes from "./logisticManager/transporterRoutes";
import riskManager_routes from "./logisticManager/riskManagerRoutes";
import manager_routes from "./logisticManager/managerRoutes";
import brokerRoutes from "./logisticManager/brokerRoutes";
import fintechRoutes from "./fintechRoutes";
import customerRoutes from "./logisticManager/customerRoutes";
import fourPl_routes from "./logisticManager/fourPlRoutes";
import auditor_routes from "./logisticManager/auditorRoutes";
import supplier_routes from "./logisticManager/supplierRoutes";
import finance_routes from "./financeRoutes";
import home_routes from "./homeRoutes";
import finance_manager_routes from "./financeManagerRoutes";
import finance_taker_routes from "./financeTakerRoutes";
import shipperRoutes from "@/http/routes/truckPositionRoutes/shipperRoutes";
import transporterRoutes from "@/http/routes/truckPositionRoutes/transporterRoutes";
import billingRoutes from "@/http/routes/billingRoutes.js";
import quotation_shipper_routes from "./quotation/shipperRoutes";
import quotation_transporter_routes from "./quotation/transporterRoutes";
import guestRoutes from "@/http/routes/guestRoutes";
export default Route.all();
